import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { tooltip } from './jss/appStyle';

const generateSafariSpacingOverrides = () => {
  const spacings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const newGridSpacing = {};
  spacings.forEach(spacing => {
    newGridSpacing[`spacing-xs-${spacing}`] = {
      width: `calc(100% + ${8 * spacing + 1}px)`,
    };
  });
  return newGridSpacing;
};

export default createTheme(
  adaptV4Theme({
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            color: '#071413',
            textTransform: 'none',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip,
        },
      },
      MuiGrid: {
        styleOverrides: {
          ...generateSafariSpacingOverrides(),
        },
      },
    },

    typography: {
      fontFamily: 'Poppins',
      fontFamily2: 'Arbutus Slab',
      h1: {
        fontSize: '32px',
        fontWeight: '500',
      },
      h2: {
        fontSize: '28px',
        fontWeight: '700',
      },
      h3: {
        fontSize: '24px',
        fontWeight: '700',
      },
      h4: {
        fontSize: '20px',
        fontWeight: '700',
      },
      h5: {
        fontSize: '20px',
        fontWeight: '500',
      },
      h6: {
        fontSize: '18px',
        fontWeight: '500',
        textTransform: 'none',
      },
      subtitle1: {
        fontSize: '16px',
        fontWeight: '500',
        textTransform: 'none',
      },
      subtitle2: {
        fontSize: '40px',
        fontWeight: '700',
      },
      subtitle3: {
        fontSize: '14px',
        fontWeight: '400',
      },
      body1: {
        fontSize: '18px',
        fontWeight: '400',
      },
      body2: {
        fontSize: '12px',
        fontWeight: '500',
      },
      caption: {
        fontSize: '12px',
      },
      button: {
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: '18px',
      },
      buttonSm: {
        fontWeight: '400',
        textTransform: 'none',
        fontSize: '14px',
      },
    },
    commonColors: {
      grey: {
        int00: '#FFFFFF',
        int50: '#BDC4CC',
        int100: '#868E96',
        int200: '#6F767D',
        int300: '#5B6066',
        int400: '#36393D',
        int500: '#000000',
      },
      stroke: {
        int100: '#E6E8ED',
        int200: '#E1E3E8',
        int300: '#D3D6DE',
        int400: '#CBCED4',
        int500: '#B7BBC4',
      },
      white: {
        int00: '#FFFFFF',
        int100: '#F9F9F9',
        int200: '#F7F7F7',
        int300: '#F3F3F3',
        int400: '#EDEDED',
        int500: '#E6E6E6',
        int600: '#C5C5C5',
        dark: '#000000',
      },
      success: {
        int50: '#E8FAEF',
        int100: '#B9F0CC',
        int200: '#97E8B3',
        int300: '#68DE90',
        int400: '#4AD87B',
        int500: '#1DCE5A',
        int600: '#1ABB52',
        int700: '#159240',
        int800: '#107132',
        int900: '#0C5726',
      },
      refund: {
        int50: '#E7F9FF',
        int100: '#B6EBFE',
        int200: '#92E2FE',
        int300: '#61D4FD',
        int400: '#42CCFD',
        int500: '#13BFFC',
        int600: '#11AEE5',
        int700: '#0D88B3',
        int800: '#0A698B',
        int900: '#08506A',
      },
      warning: {
        int50: '#FEF1E6',
        int100: '#FCD5B2',
        int200: '#FAC08D',
        int300: '#F8A359',
        int400: '#F69139',
        int500: '#F47607',
        int600: '#DE6B06',
        int700: '#AD5405',
        int800: '#864104',
        int900: '#663203',
      },
      declined: {
        int50: '#FFE7E7',
        int100: '#FEB6B6',
        int200: '#FD9292',
        int300: '#FC6060',
        int400: '#FC4141',
        int500: '#FB1212',
        int600: '#E41010',
        int700: '#B20D0D',
        int800: '#8A0A0A',
        int900: '#690808',
      },
    },
  }),
);
